import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const utilityItemCodeLocaleModule: LocaleModule = {
  name: "utilityItemCode",
  messages: { en: en, it: it },
};
